module.exports = __webpack_public_path__ + "static/media/fab.1fb4c271.png";